import { CalendarDays, Home, Settings } from 'lucide-preact'

export type Tab = 'today' | 'month' | 'settings'

export function BottomNav({
  tab,
  onSelect,
}: {
  tab: Tab
  onSelect: (tab: Tab) => void
}) {
  return (
    <nav class="bottom-nav">
      <button class={tab === 'today' ? 'active' : ''} onClick={() => onSelect('today')}>
        <Home size={21} />
        <span>Aujourd’hui</span>
      </button>
      <button class={tab === 'month' ? 'active' : ''} onClick={() => onSelect('month')}>
        <CalendarDays size={21} />
        <span>Mois</span>
      </button>
      <button class={tab === 'settings' ? 'active' : ''} onClick={() => onSelect('settings')}>
        <Settings size={21} />
        <span>Réglages</span>
      </button>
    </nav>
  )
}
